import {useQuery} from "@apollo/client";

import {GQL_RESOLVE_STATUSPAGE_BY_HOST} from "@/lib/queries/statusPageConsumption.ts";

interface HostResolution {
  slug: string | null;
  serving_mode: "LEGACY" | "SPA";
}

// Resolve the current custom-domain host to an SPA-served status-page slug. Only SPA-mode
// pages resolve (routing legacy domains to Django is the edge's job). Cached by Apollo
// (cache-first) so the root and drilldown routes share a single network request, while a
// hard refresh of a deep route still re-resolves on its own.
export const useHostResolvedSlug = (): {slug: string | undefined; loading: boolean} => {
  const {data, loading} = useQuery<{resolveStatusPageByHost: HostResolution | null}>(GQL_RESOLVE_STATUSPAGE_BY_HOST, {
    variables: {host: window.location.hostname},
    // The host→slug mapping is stable for the lifetime of the page load, so resolve it
    // once instead of re-fetching on every mount (the app default is cache-and-network).
    fetchPolicy: "cache-first",
  });
  const resolution = data?.resolveStatusPageByHost;
  const slug = resolution?.serving_mode === "SPA" ? (resolution.slug ?? undefined) : undefined;
  return {slug, loading};
};
